
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true,\"url\":true,\"alias\":{\"fonts\":\"..fonts\"}}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-cc0ee130\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SemPermissao.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SemPermissao.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-cc0ee130\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SemPermissao.vue"),
  /* scopeId */
  "data-v-cc0ee130",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/sem-permissao/SemPermissao.vue
// module id = 1071
// module chunks = 1